import {alt} from 'epic-react-common';
import Immutable from 'seamless-immutable';
import {seamlessImmutable} from 'epic-alt-utils';

@seamlessImmutable
class RedeemConfigStore {
  constructor() {
    this.on('error', (error) => {
      console.error(error);
    });
    this.state = Immutable({
      config: {},
    });
  }
}

export default alt.createStore(RedeemConfigStore, 'RedeemConfigStore');
